const getTravelerIndex = (travelers, target) => typeof target === 'number'
  ? target
  : travelers.indexOf(target);

export const updateTraveler = (travelers, target, update) => {
  const targetIndex = getTravelerIndex(travelers, target);
  if (targetIndex < 0) return travelers;

  return travelers.map((traveler, index) => index === targetIndex
    ? {...traveler, ...(typeof update === 'function' ? update(traveler) : update)}
    : traveler);
};

export const updateNestedTraveler = (travelers, target, nestedKey, update) => updateTraveler(
  travelers,
  target,
  traveler => ({
    [nestedKey]: {
      ...(traveler[nestedKey] || {}),
      ...(typeof update === 'function' ? update(traveler[nestedKey] || {}) : update),
    },
  }),
);

export const updateAllTravelers = (travelers, update) => travelers.map(traveler => ({
  ...traveler,
  ...(typeof update === 'function' ? update(traveler) : update),
}));

export const selectExclusiveTraveler = (travelers, target, key, value) => {
  const targetIndex = getTravelerIndex(travelers, target);
  return travelers.map((traveler, index) => ({
    ...traveler,
    [key]: index === targetIndex ? value : false,
  }));
};